import { render, staticRenderFns } from "./application-tabs.vue?vue&type=template&id=bfe2b348"
import script from "./application-tabs.vue?vue&type=script&lang=js"
export * from "./application-tabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports